import * as RongIMLib from '@rongcloud/imlib-next';
import { defineCustomElements, imkit } from '@rongcloud/imkit';
import { customService, messageService, conversationService, customDisplayMessage } from '~/api/p2p/im-services';

const domain_env = import.meta.env.VITE_DOMAIN_ENV;

/** 注意替换不同环境的APPKEY  测试 pwe86ga5pntt6  线上 bmdehs6pb2hws */
const APPKEY = domain_env === 'production' ? 'tdrvipkstuq05' :"k51hidwqkzn8b";//"bmdehs6pb2hws";//"pwe86ga5pntt6";

export default defineNuxtPlugin(nuxtApp => {
  // 异步动态import
  
  if(process.client){
    // nuxtApp.hook('app:beforeMount', () => {
      // console.log("domain is", domain_env);
      defineCustomElements();
      const level =  1; //domain_env === 'production'?1:3;
      RongIMLib.init({appkey: APPKEY,logOutputLevel: level});
      imkit.init({
       appkey: APPKEY,
       service: customService,
       libOption: {appkey: APPKEY,logOutputLevel: level},
       customIntercept: conversationService,
       customMessage: messageService,
       customDisplayMessage: customDisplayMessage
      });
      const AccountMessage = imkit.registerMessageType('BM:AccountMsg', true, true, [], false);
      // const NotifyMessage = imkit.registerMessageType('kit:notify', true, true, [], false);
      
      window.AccountMessage = AccountMessage;
      // window.NotifyMessage = NotifyMessage;
      window.imkit = imkit;
    // });
    
    // window.APPKEY = APPKEY;
    // nuxtApp.vueApp.use(IMPlugin);
  }
  
});
